import { Route, Switch } from 'react-router-dom';

import { Routes } from '../../enums/routes';
import { ContactManagementPage } from '../../../contact-management/components/contact-management-page';
import { SuppressionPage } from '../../../suppression/components/suppression-page';
import { ContentManagementPage } from '../../../content-management/components/content-management-page';
import { AcquisitionSegmentsPage } from '../../../acquisition-segments/components/acquisition-segments-page';
import { RetentionSegmentsPage } from '../../../retention-segments/components/retention-segments-page';
import { CampaignManagementPage } from '../../../campaign-management/components/campaign-management-page';
import { AnalyticsPage } from '../../../analytics/components/analytics-page';
import { AutopilotCampaignsPage } from '../../../autopilot-campaigns/components/autopilot-campaigns-page';

export function AppRoutes() {
    /**
     * Placeholders for page. Should be replaced with dedicated routes e.g.
     *
     * <Route path={Routes.Search} exact><PageComponent /></Route>
     * ...
     */

    return (
        <Switch>
            <Route exact path="/audiences/mcm/**">
                <ContactManagementPage />
            </Route>

            <Route path={Routes.Suppression}>
                <SuppressionPage />
            </Route>

            <Route path={Routes.AnalyticsSection}>
                <AnalyticsPage />
            </Route>

            <Route path={Routes.CampaignManager}>
                <CampaignManagementPage />
            </Route>
            <Route exact path={`${Routes.AcquisitionSegments}**`}>
                <AcquisitionSegmentsPage />
            </Route>
            <Route exact path={`${Routes.RetentionSegments}**`}>
                <RetentionSegmentsPage />
            </Route>
            <Route path="/campaigns/email-template/**">
                <ContentManagementPage />
            </Route>
            <Route path={Routes.AutopilotCampaigns}>
                <AutopilotCampaignsPage />
            </Route>
        </Switch>
    );
}
